import { render } from "./TracksContainerFromAlbum.vue?vue&type=template&id=5f1ceaff"
import script from "./TracksContainerFromAlbum.vue?vue&type=script&lang=js"
export * from "./TracksContainerFromAlbum.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__